const config = {
  wsStage: 'pro',
  configStage: 'pro',
  lang: 'es',
  channel: 'webchat',
  testMode: true,
  maximizeOnLoad: false,
};

export default config;



// WEBPACK FOOTER //
// ./src/configs/rt_pro.js